import { useContext, useState } from "react";
import { ProductCategoryGroupTableColumns } from "../../../configs/products";
import { ROLE } from "../../../data/enums";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import ListView from "../../../shared/components/ListView";
import AddIcon from "../../../shared/svg/AddIcon";
import apiMethods from "../../../utils/api";
import { error, success } from "../../../utils/toast";
import AddCategoryGroupModal from "./AddCategoryGroupModal";
import ProductCategoryGroupRow from "./ProductCategoryGroupTableRow";
import { ProductCategoryGroupButtonRow, StyledButton } from "./style";

const ProductCategoryGroups = () => {
    const [refresh, setRefresh] = useState(false);

    const [openAddCategoryGroupModal, setOpenAddCategoryGroupModal] =
        useState(false);

    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const canCreateProductCategoryGroup = [
        ROLE.MANAGER,
        ROLE.FIRST_STORAGE_KEEPER,
        ROLE.SECOND_STORAGE_KEEPER,
    ].includes(role);

    const handleAddCategoryGroup = async (name: string) => {
        try {
            await apiMethods.post("/products/category-groups/", { name });
            setOpenAddCategoryGroupModal(false);
            if (setRefresh) {
                setRefresh((prev: boolean) => !prev);
            }
            success(
                "Thêm nhóm danh mục thành công",
                "Thêm nhóm danh mục thành công",
            );
        } catch (err) {
            error("Thêm nhóm danh mục thất bại", err);
        }
    };

    const createProductCategoryGroupButton = [
        {
            isViewed: canCreateProductCategoryGroup,
            element: (
                <ProductCategoryGroupButtonRow>
                    <StyledButton
                        variant="contained"
                        onClick={() => setOpenAddCategoryGroupModal(true)}
                    >
                        <AddIcon />
                        Thêm nhóm danh mục
                    </StyledButton>
                </ProductCategoryGroupButtonRow>
            ),
        },
    ];

    return (
        <>
            {openAddCategoryGroupModal && (
                <AddCategoryGroupModal
                    open={openAddCategoryGroupModal}
                    handleClose={() => setOpenAddCategoryGroupModal(false)}
                    handleConfirm={handleAddCategoryGroup}
                />
            )}

            <ListView
                url="/products/category-groups/"
                rowElement={ProductCategoryGroupRow}
                tableColumns={ProductCategoryGroupTableColumns}
                refresh={refresh}
                textString="Tìm kiếm theo tên Mã nhóm sản phẩm, Tên nhóm sản phẩm"
                rightButtons={createProductCategoryGroupButton}
            />
        </>
    );
};

export default ProductCategoryGroups;